import { zodResolver } from "@hookform/resolvers/zod";

import {
  AppCreate,
  AppSimpleForm,
  AppFormToolbar,
  AppFormSection,
  SectionHeader,
  AppFormContent,
  AppTextInput,
} from "@/adapters/inbound/layout";
import {
  personCreateFormSchema,
  type PersonCreateFormInput,
} from "../schemas";
import { toCreatePersonCommand } from "../mappers";

export const defaultPersonCreateFormValues: PersonCreateFormInput = {
  displayName: "",
  preferredName: "",
  mobilePhoneE164: "",
  email: "",
  canAppearInPhoto: false,
};

function PersonCreateFields() {
  return (
    <>
      <AppTextInput
        source="displayName"
        label="Name"
        required
        autoFocus
        fullWidth
      />
      <AppTextInput
        source="preferredName"
        label="Bevorzugter Name"
        fullWidth
      />
      <AppTextInput
        source="mobilePhoneE164"
        label="Mobilnummer"
        type="tel"
        helperText="Optional"
        fullWidth
      />
      <AppTextInput
        source="email"
        label="E-Mail"
        type="email"
        fullWidth
      />
    </>
  );
}

export function PersonCreate() {
  return (
    <AppCreate transform={toCreatePersonCommand} redirect="show">
      <AppSimpleForm
        defaultValues={defaultPersonCreateFormValues}
        resolver={zodResolver(personCreateFormSchema) as any}
        mode="onBlur"
        shouldUnregister
        toolbar={<AppFormToolbar showDelete={false} />}
      >
        <AppFormSection>
          <SectionHeader
            title="Mitarbeiter anlegen"
            subtitle="Grunddaten der Person erfassen."
          />
          <AppFormContent>
            <PersonCreateFields />
          </AppFormContent>
        </AppFormSection>
      </AppSimpleForm>
    </AppCreate>
  );
}
